import React from 'react';
//
import { ModalContainerDark, AlertModal, AlertModalUnauth, OptionModal } from 'components/modal-provider/modal';
import { IModalState } from 'store/modal/types';

export default ({ content, visible, optionModal }: IModalState) => {
  if (visible) {
    const alertModalType =
      content?.props.title === 'Roles and Business Communication' ? (
        <AlertModalUnauth>{content}</AlertModalUnauth>
      ) : (
        <AlertModal>{content}</AlertModal>
      );
    return (
      <ModalContainerDark>{optionModal ? <OptionModal>{content}</OptionModal> : alertModalType}</ModalContainerDark>
    );
  }

  return null;
};
